module.exports = __webpack_public_path__ + "static/media/FAQ-doc.0e68032a.pdf";